import { type ReactNode } from 'react';
import { cn } from '@shared/lib/cn';

/**
 * Editorial empty state — no cartoonish illustrations. Large serif copy,
 * optional supporting body, optional CTA. Per design spec, every list and
 * detail screen ships an empty state of this shape.
 */
interface EmptyStateProps {
  /** Required serif headline (Fraunces). Examples: "No requests yet." */
  title: string;
  description?: string;
  action?: ReactNode;
  /** Optional small icon or glyph above the title. */
  icon?: ReactNode;
  className?: string;
}

export function EmptyState({ title, description, action, icon, className }: EmptyStateProps): JSX.Element {
  return (
    <div className={cn('flex flex-col items-center justify-center text-center px-6 py-12', className)}>
      {icon ? <div className="mb-4 text-ink-muted">{icon}</div> : null}
      <h2 className="font-display text-display-lg text-ink">{title}</h2>
      {description ? (
        <p className="text-body text-ink-secondary mt-2 max-w-sm">{description}</p>
      ) : null}
      {action ? <div className="mt-6">{action}</div> : null}
    </div>
  );
}
